// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsProductInfoStyles } from "@conklin/App/Widgets/ProductDetails/ProductDetailsProductInfo";
import { color, hideElementOnPrint } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

productDetailsProductInfoStyles.wrapper = {
    css: css``,
};

productDetailsProductInfoStyles.separator = {
    css: css`
        width: 100%;
        height: 1px;
        border-top: 1px solid ${color("common.border")};
        margin: 12px 0;
        ${hideElementOnPrint}
    `,
};

productDetailsProductInfoStyles.requestQuote = {
    sizeVariant: "small",
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};

productDetailsProductInfoStyles.productActionsStyle = {
    addToCartContainer: {
        css: css`
            ${hideElementOnPrint}
        `,
    },
};

productDetailsProductInfoStyles.multiplesOf = {
    size: 12,
    lineHeight: "15px",
    css: css`
        display: block;
        margin-bottom: 2px;
        ${hideElementOnPrint}
    `,
};
